import React from 'react'
import PaginationData from './PaginationData'
import './Pagination.css'

function Pagination({onLimit, onPagination, paginationData}) {
  const pagination = new PaginationData(paginationData)
  if (!pagination.hasPrevious() && !pagination.hasNext()) {
    return null
  }
  return (
    <div className='navigation flex-shrink-0' style={{textAlign: 'center', margin: '15px 0'}}>
      
      <div className='nav'>

        {pagination.hasPrevious() &&
        <a
          className='prev'

          onClick={() => {
            onPagination(pagination.page - 1)
          }}
          title='Перейти на предыдущую страницу'>&lt;</a>}
        {!pagination.hasPrevious() &&
        <span
          className='prev'
          title='Перейти на предыдущую страницу'><em>&lt;</em></span>}
        {pagination.getRange(9).map((item) => {
          return pagination.page === item
            ? <span key={111} className='goto'>
              <em>
                <span>{item + 1}</span>
              </em>
            </span>
            : <span key={item} className='goto'>
              <a

                onClick={() => {
                  onPagination(item)
                }}
              >
                <span>{item + 1}</span>
              </a>
            </span>
        })}
        {pagination.hasNext() &&
        <a
          className='next'

          onClick={() => {
            onPagination(pagination.page + 1)
          }}
          title='Перейти на следующую страницу'>&gt;</a>}
        {!pagination.hasNext() &&
        <span
          className='next'
          title='Перейти на следующую страницу'><em>&gt;</em></span>}
        {pagination.hasNext() &&
        <a
          className='last'

          onClick={() => {
            onPagination(pagination.lastPage)
          }}
          title='Перейти на последнюю страницу'>&gt;&gt;</a>}
      </div>
    </div>
  )
}

export default Pagination



// WEBPACK FOOTER //
// ./src/pages/pagination/index.js